// React
import { createContext } from "react"

// Types
import type { SelectOptionType } from "types"

export const AccountContext = createContext<{
  data: SelectOptionType[]
  isLoading: boolean
}>({
  data: [],
  isLoading: false
})